import jwtAxios from '../axios';
import { endPoints } from '../endpoints';
import {
  CreateConversationParams,
  ListConversationsParams,
  UpdateConversationParams,
} from '@nxsys/store/slices/message/types';

// ==================== Conversation APIs ====================

export const createConversationApi = async (data: CreateConversationParams) => {
  const response = await jwtAxios.post(endPoints.conversation.main, data);
  return response.data;
};

export const listConversationsApi = async (params: ListConversationsParams) => {
  const { status, participantUserIds, includeParticipants, ...rest } = params;
  const query: Record<string, any> = { ...rest };
  if (status) query.status = status;
  const response = await jwtAxios.get(endPoints.conversation.main, {
    params: query,
    paramsSerializer: (p: Record<string, any>) => {
      const searchParams = new URLSearchParams();
      Object.entries(p).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          searchParams.append(key, String(value));
        }
      });
      participantUserIds?.forEach((id) => {
        searchParams.append('participantUserIds[]', id);
      });
      includeParticipants?.forEach((type) => {
        searchParams.append('includeParticipants[]', type);
      });
      return searchParams.toString();
    },
  });
  return response.data;
};

export const getConversationApi = async (id: number) => {
  const response = await jwtAxios.get(endPoints.conversation.detail(id));
  return response.data;
};

export const updateConversationApi = async (
  id: number,
  data: Partial<Omit<UpdateConversationParams, 'id'>>,
) => {
  const response = await jwtAxios.put(endPoints.conversation.detail(id), data);
  return response.data;
};

export const sendMessageApi = async (
  conversationId: number,
  data: { uuid?: string; content: string },
) => {
  const response = await jwtAxios.post(
    endPoints.conversation.messages(conversationId),
    data,
  );
  return response.data;
};

export const listMessagesApi = async (
  conversationId: number,
  params: { cursor?: number; limit?: number },
) => {
  const response = await jwtAxios.get(
    endPoints.conversation.messages(conversationId),
    { params },
  );
  return response.data;
};

export const markConversationReadApi = async (id: number) => {
  const response = await jwtAxios.post(endPoints.conversation.read(id));
  return response.data;
};

export const archiveConversationApi = async (id: number) => {
  const response = await jwtAxios.post(endPoints.conversation.archive(id));
  return response.data;
};

export const unarchiveConversationApi = async (id: number) => {
  const response = await jwtAxios.post(endPoints.conversation.unarchive(id));
  return response.data;
};

export const getUnreadCountApi = async () => {
  const response = await jwtAxios.get(endPoints.conversation.unreadMessages);
  return response.data;
};

export const getUnreadConversationsAndMessagesApi = async () => {
  const response = await jwtAxios.get(
    endPoints.conversation.unreadConversationsAndMessages,
  );
  return response.data;
};

// ==================== Recipient Search APIs ====================

export const searchAgencyApi = async (params: Record<string, any>) => {
  const response = await jwtAxios.get(endPoints.agency.main, {
    params: { type: 'SEARCH', page: 0, size: 20, ...params },
  });
  return response.data;
};

export const searchSubcontractorApi = async (params: Record<string, any>) => {
  const response = await jwtAxios.get(endPoints.user.subcontractors, {
    params,
  });
  return response.data;
};

export const getEmployerListApi = async (params: Record<string, any>) => {
  const response = await jwtAxios.get(endPoints.message.employerList, {
    params,
  });
  return response.data;
};

export const getCompanyListByEmployeeApi = async () => {
  const response = await jwtAxios.get(endPoints.message.allCompanyByEmployee);
  return response.data;
};

export const getAdminUsersApi = async (params: Record<string, any>) => {
  const response = await jwtAxios.get(endPoints.user.admin, { params });
  return response.data;
};

export const getAgencyListBySubcontractorApi = async (
  subcontractorId: string,
  params?: Record<string, any>,
) => {
  const response = await jwtAxios.get(
    `/subcontractor/agency-list/${subcontractorId}`,
    { params },
  );
  return response.data;
};
